import { IDENTITY_KEYS } from './profile-document';

// Filesystem-safe: no colons (illegal on Windows), no spaces, no slashes.
const slug = (value) =>
  String(value ?? '')
    .trim()
    .replace(/[^A-Za-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

// ISO 8601 basic, to the second: 20260821T143011Z.
const timestamp = (exportedAt) =>
  new Date(exportedAt)
    .toISOString()
    .replace(/[-:]/g, '')
    .replace(/\.\d{3}Z$/, 'Z');

export const profileDocumentFilename = ({ environment, siteName, kind, identity, exportedAt }) => {
  const identityPart = IDENTITY_KEYS[kind]
    .map((key) => identity?.[key])
    .filter(Boolean)
    .map(slug)
    .join('-');
  return [slug(environment), slug(siteName), slug(kind), identityPart, timestamp(exportedAt)]
    .filter(Boolean)
    .join('_')
    .concat('.json');
};
